
































































































































































































































































































































































































helpers = require('../../helpers.coffee')

view_model =
  components:
    carouselModal: require './modal_carousel.vue'
    textImage: require '../shared/text_image.vue'
    vtiger: require './integrations/vtiger.vue'
    hubspot: require './integrations/hubspot.vue'
    rd_station: require './integrations/rd_station.vue'
    triggerStages: require './integrations/trigger_stages.vue'
    integration: require './integrations/index.vue'

  data: ->
    current_user: Session.current_user
    rd_station_setting: if Session.current_user.rd_station_setting.id? then Session.current_user.rd_station_setting else new RdStationSetting()
    salesforce_setting: if Session.current_user.salesforce_setting.id? then Session.current_user.salesforce_setting else new SalesforceSetting()
    pipedrive_setting: if Session.current_user.pipedrive_setting.id? then Session.current_user.pipedrive_setting else new PipedriveSetting()
    crm_setting: if Session.current_user.crm_setting.id? then Session.current_user.crm_setting else new CRMSetting()
    nectar_setting: if Session.current_user.nectar_setting.id? then Session.current_user.nectar_setting else new NectarSetting()
    webhook_url: if Session.current_user.webhook_setting.id? then Session.current_user.webhook_setting.url else 'https://'
    salesforce_authorized: Session.current_user.salesforce_setting?.access_token?
    rdstation_authorized: Session.current_user.rd_station_setting?.authorized
    selectedRD: Session.current_user.rd_station_setting?.mark_lead_as_sale
    create_on_add_to_nectar: Session.current_user.nectar_setting.create_on_add
    nectar_api_key: Session.current_user.nectar_api_key || ''
    show_form: false
    show_form_bcc: false
    show_form_rd: false
    show_form_sp: false
    show_form_ll: false
    show_form_nectar: false
    show_form_salesforce: false
    copied_rd: false
    copied_sp: false
    copied_ll: false
    rd_carousel: null
    sp_carousel: null
    conectedToNylas: false
    show_api_token: false
    show_carousel: false
    carousel: null
    webhook_triggers: {}
    sharpspring_setting: if Session.current_user.sharpspring_setting.id? then Session.current_user.sharpspring_setting else new SharpspringSetting()
    leadlovers_setting: if Session.current_user.leadlovers_setting.id? then Session.current_user.leadlovers_setting else new LeadloversSetting()

  computed:
    sp_url: ->
      if @has_configured_sp_carousel || !@sharpspring_setting.use_carousel
        process.env.API_URL + '/webhooks/sharp_spring/import_contacts?token=' + @current_user.authentication_token
      else
        this.$t('integrations.feedback.sharpspringNeedsCarousel')

    leadloversSet: ->
      if Session.current_user.leadlovers_setting.id?
        true
      else
        false

    ll_url: ->
      process.env.API_URL + '/webhooks/lead_lovers/import_contacts?token=' + @current_user.authentication_token

    salesforce_mark_as: ->
      if @salesforce_setting.mark_as == 'lead_and_opportunity'
        true
      else
        false

    salesforce_send_to: ->
      if @salesforce_setting.send_to == 'queue'
        true
      else
        false

    has_configured_rd_carousel: ->
      @rd_carousel? && @rd_carousel.carousel_users.length > 0

    has_configured_sp_carousel: ->
      @sp_carousel? && @sp_carousel.carousel_users.length > 0

    webhook_error: ->
      error = @errors.first('webhook_url')
      return unless error
      error + this.$t('integrations.feedback.rememberHttps')

    nylasOauthUrl: ->
      params = jQuery.param(
        client_id: process.env.NYLAS_CLIENT_ID
        response_type: 'code'
        scopes: process.env.NYLAS_SCOPES
        login_hint: Session.current_user.email
        redirect_uri: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'nylas'
      )
      "https://api.nylas.com/oauth/authorize?#{params}"

    salesforceOauthUrl: ->
      client_id = if Session.current_user.new_ui then process.env.SALESFORCE_BETA_CLIENT_ID else process.env.SALESFORCE_CLIENT_ID

      params = jQuery.param(
        client_id: client_id
        response_type: 'code'
        redirect_uri: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'salesforce,'+@salesforce_setting.sandbox_test
      )
      if @salesforce_setting.sandbox_test
        "https://test.salesforce.com/services/oauth2/authorize?#{params}"
      else
        "https://login.salesforce.com/services/oauth2/authorize?#{params}"

    rdStationOauthUrl: ->
      params = jQuery.param(
        client_id: process.env.RDSTATION_CLIENT_ID
        redirect_url: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'rdstation'
      )
      "https://api.rd.services/auth/dialog?#{params}"

    email_authorized: ->
      @current_user.email_authorized && !@current_user.requireEmailReauthorization()

  methods:
    toggleSendTasks: ->
      @nectar_setting.send_tasks = !@nectar_setting.send_tasks
    use_carousel_rd: ->
      if @rd_station_setting.use_carousel
        return this.$t('integrations.label.contactsViaCarousel')
      this.$t('integrations.label.contactsViaResponsible')

    use_carousel_sp: ->
      if @sharpspring_setting.use_carousel
        return this.$t('integrations.label.contactsViaCarousel')
      this.$t('integrations.label.contactsViaResponsible')

    checkboxSelectRD: ->
      return if !@rdstation_authorized && @rd_station_setting.use_carousel
      @selectedRD = !@selectedRD
      if @selectedRD
        if @rd_station_setting.triggers.stages.indexOf('client') == -1
          @rd_station_setting.triggers.stages.push('client')
      else
        @rd_station_setting.triggers.stages.pop()
      @updateRdStationSetting()

    fillRdCarousel: (carousel) ->
      @rd_carousel = carousel

    fillSpCarousel: (carousel) ->
      @sp_carousel = carousel

    fillCarousel: (carousel) ->
      @carousel = carousel

    modalTitle: ->
      if @current_user.isSeller() then this.$t('integrations.attributes.Carousel') else this.$t('integrations.label.setCarousel')

    loadRdCarouselData: ->
      @$refs.rd_carousel_modal.loadData()

    loadSpCarouselData: ->
      @$refs.sp_carousel_modal.loadData()

    loadCarouselData: ->
      @$refs.carousel_modal.loadData()

    copyURLsp: ->
      jQuery('#sp_url').select()
      document.execCommand("copy")
      @copied_sp = true

    copyURLll: ->
      jQuery('#ll_url').select()
      document.execCommand("copy")
      @copied_ll = true

    copyApiToken: ->
      jQuery('input#api-token').select()
      document.execCommand("copy")

    toggleSalesforceMarkAs: ->
      if @salesforce_setting.mark_as == 'lead_and_opportunity'
        @salesforce_setting.mark_as = 'only_lead'
      else
        @salesforce_setting.mark_as = 'lead_and_opportunity'

    toggleSalesforceSendTo: ->
      if @salesforce_setting.send_to == 'responsible'
        @salesforce_setting.send_to = 'queue'
      else
        @salesforce_setting.send_to = 'responsible'

    toggleMarkAddContatsToNectar: ->
      @create_on_add_to_nectar = !@create_on_add_to_nectar

    saveNectar: ->
      @$validator.validateAll({@nectar_api_key}).then (success) =>
        @updateNectarApiKey() if success

    updateNectarApiKey: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        @nectar_api_key,
        nectar_setting_attributes: {
          id: @nectar_setting.id,
          pipeline_id: @nectar_setting.pipeline_id,
          stage_number: @nectar_setting.stage_number,
          send_tasks: @nectar_setting.send_tasks,
          triggers: @nectar_setting.triggers,
          responsible: @nectar_setting.responsible
        }
      }
      new UsersResource().update(@updateNectarApiKeySuccess, @handleApiErrors, params)

    updateSalesforceSetting: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        salesforce_setting_attributes: {
          id: @salesforce_setting.id,
          mark_as: @salesforce_setting.mark_as,
          send_to: @salesforce_setting.send_to,
          triggers: @salesforce_setting.triggers
        }
      }
      new UsersResource().update(@updateSalesforceSettingSuccess, @handleApiErrors, params)

    removeNectarApiKey: ->
      @nectar_api_key = null
      @updateNectarApiKey()

    updateSalesforceSettingSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('general.feedback.settingUpdated')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @closeForm()

    updateNectarApiKeySuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.nectar_api_key then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.feedback.nectarSuccess')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @nectar_api_key = Session.current_user.nectar_api_key
      @closeForm()
      intercom_event_name = if data.user.nectar_api_key then this.$t('integrations.feedback.connectedToNectar') else this.$t('integrations.feedback.disconnectedToNectar')
      IntercomCtrl.trackEvent(intercom_event_name)

    openConectPipedriveForm: ->
      @show_form = !@show_form
      @show_form_bcc = false
      @show_form_salesforce = false
      @show_form_sp = false
      @show_form_ll = false
      @show_form_nectar = false
      @show_form_rd = false

    openConectNectarForm: ->
      @nectar_setting.responsible = Session.current_user.email unless @nectar_setting.responsible
      @show_form_nectar = !@show_form_nectar
      @show_form_rd = false
      @show_form = false
      @show_form_bcc = false
      @show_form_salesforce = false
      @show_form_sp = false
      @show_form_ll = false

    openConectSalesForceForm: ->
      @show_form_salesforce = !@show_form_salesforce
      @show_form_nectar = false
      @show_form_rd = false
      @show_form = false
      @show_form_bcc = false
      @show_form_sp = false
      @show_form_ll = false

    openConectRDForm: ->
      @show_form_rd = !@show_form_rd
      @show_form_nectar = false
      @show_form = false
      @show_form_bcc = false
      @show_form_salesforce = false
      @show_form_sp = false
      @show_form_ll = false

    openConectSPForm: ->
      @show_form_sp = !@show_form_sp
      @show_form_ll = false
      @show_form_rd = false
      @show_form_nectar = false
      @show_form = false
      @show_form_bcc = false
      @show_form_salesforce = false

    openConectLLForm: ->
      @show_form_ll = !@show_form_ll
      @show_form_sp = false
      @show_form_rd = false
      @show_form_nectar = false
      @show_form = false
      @show_form_bcc = false
      @show_form_salesforce = false

    saveBcc: ->
      @updatePipedriveBcc()

    saveWebhookUrl: ->
      @$validator.validateAll({@webhook_url}).then (success) =>
        @updateWebhookURL() if success

    updatePipedriveBcc: ->
      Loader.on()

      params = {
        id: Session.current_user.id,
        crm_setting_attributes: {
          id: @crm_setting.id,
          bcc_send_email: @crm_setting.bcc_send_email,
          bcc_reply_email: @crm_setting.bcc_reply_email
        }
      }
      new UsersResource().update(@updatecrmBccSuccess, @handleApiErrors, params)

    updatecrmBccSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('general.feedback.settingSaved')
      @trackIntercomBccUpdate(data.user.crm_setting)
      Session.signIn(response.body.user)
      @crm_setting = Session.current_user.crm_setting
      @closeForm()

    updateWebhookSuccess: (data, response) ->
      Loader.off()
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      alertify.success this.$t('general.feedback.settingSaved')
      @closeForm()

    updateWebhookURL: ->
      Loader.on()

      if (@webhook_triggers.on_created == undefined)
        @webhook_triggers = Session.current_user.webhook_setting.triggers

      params = {
        id: Session.current_user.id,
        webhooks_attributes: {
          id: Session.current_user.webhook_setting.id || null,
          event: 'ChangeContactStage',
          url: @webhook_url,
          triggers: @webhook_triggers
          user_change: @webhook_triggers.on_change
        }
      }

      new UsersResource().update(@updateWebhookSuccess, @webHookErrors, params)

    saveSharpSpring: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        sharpspring_setting_attributes: {
          id: Session.current_user.sharpspring_setting.id || null,
          triggers: @sharpspring_setting.triggers,
          use_carousel: @sharpspring_setting.use_carousel
        }
      }
      new UsersResource().update(@updateWebhookSuccess, @SharpSpringErrors, params)

    SharpSpringErrors: (data, response) ->
      Loader.off()
      alertify.error this.$t('general.feedback.updateError')

    saveLeadlovers: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        leadlovers_setting_attributes: {
          id: Session.current_user.leadlovers_setting.id || null,
          triggers: @leadlovers_setting.triggers,
          use_carousel: @leadlovers_setting.use_carousel
        }
      }
      new UsersResource().update(@updateLeadloversSuccess, @LeadloversErrors, params)

    removeLeadlovers: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        leadlovers_setting_attributes: {
          id: @leadlovers_setting.id,
          _destroy: true
        }
      }
      new UsersResource().update(@updateLeadloversSuccess, @LeadloversErrors, params)

    updateLeadloversSuccess: (data, response) ->
      Loader.off()
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      alertify.success this.$t('general.feedback.settingSaved')
      window.location.reload()

    LeadloversErrors: (data, response) ->
      Loader.off()
      alertify.error this.$t('general.feedback.updateError')

    webHookErrors: (data, response) ->
      Loader.off()
      alertify.error this.$t('general.feedback.invalidUrl')

    openBccForm: ->
      @show_form_bcc = !@show_form_bcc
      @show_form = false

    closeForm: ->
      @nectar_api_key = ''
      @show_form = false
      @show_form_bcc = false
      @show_form_nectar = false
      @show_form_salesforce = false
      @errors.clear()

    trackIntercomBccUpdate: (pipedrive_setting) ->
      metadata = {
        'BCC para envio': pipedrive_setting.bcc_send__email || this.$t('general.actions.notConfigured'),
        'BCC para resposta': pipedrive_setting.bcc_reply_email || this.$t('general.actions.notConfigured')
      }
      IntercomCtrl.trackEvent(this.$t('integrations.feedback.configuredBCCPipedrive'), metadata)

    redirectToNylasOauthUrl: ->
      if !@current_user.default_user
        return alertify.error(@$t('integrations.actions.email.setUp.error.defaultUserError'))

      if @email_authorized
        @undoNylasConnection()
      else
        Loader.on()
        window.location = @nylasOauthUrl

    undoNylasConnection: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        undo_nylas_connection: true
      }
      new UsersResource().update(@updateNylasConnectionSuccess, @webHookErrors, params)

    updateNylasConnectionSuccess: (data, response) ->
      Loader.off()
      Session.current_user.email_authorized = false
      Session.current_user.email_account_status = null
      alertify.success this.$t('general.feedback.settingUpdated')

    authorizeNylas: ->
      Loader.on()
      code = @$route.query.code
      @$router.replace(name: 'integrations')
      IntegrationsResource.authorize_nylas(
        @authorizeNylasSuccess,
        @authorizeNylasFailure,
        code: code
      )
      EventsBus.$emit 'email-account-connected'

    authorizeNylasSuccess: (response) ->
      Session.updateCurrentUser(response.body.user)
      @current_user = Session.current_user
      Loader.off()
      alertify.success(this.$t('general.feedback.configEmailSuccess'))
      setTimeout(@validateCalendar, 4000)

    authorizeNylasFailure: (response) ->
      Loader.off()
      alertify.error(response.body.error, 10)

    validateCalendar: ->
      jQuery.ajax({
        url: process.env.NYLAS_URL + "/calendars",
        type: 'GET',
        headers: {
          'Authorization': Session.current_user.nylas_setting.access_token
        },
        success: @successLoadCalendar,
        error: @failureLoadCalendar
      });

    successLoadCalendar: (response) ->
      for calendar in response
        if calendar.name == Session.current_user.email
          params = {
            id: Session.current_user.id,
            nylas_setting_attributes: {
              id: Session.current_user.nylas_setting.id,
              calendar_id: calendar.id
            }
          }
          new UsersResource().update(@updateCalendarSuccess, @handleApiErrors, params)
          return

      @validateReadOnlyCalendar(response)

    validateReadOnlyCalendar: (response) ->
      for calendar in response
        if !calendar.read_only
          params = {
            id: Session.current_user.id,
            nylas_setting_attributes: {
              id: Session.current_user.nylas_setting.id,
              calendar_id: calendar.id
            }
          }
          new UsersResource().update(@updateCalendarSuccess, @handleApiErrors, params)
          return

      setTimeout(@validateCalendar, 4000)

    failureLoadCalendar: (response) ->
      alertify.error(this.$t('integrations.feedback.calendarFail'))

    updateCalendarSuccess: (data, response) ->
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      alertify.success(this.$t('integrations.feedback.calendarSuccess'))
      window.location.reload()

    redirectToSalesforceOauthUrl: ->
      if @salesforce_authorized
        Loader.on()
        params = {
          id: Session.current_user.id,
          salesforce_setting_attributes: {
            id: @salesforce_setting.id,
            _destroy: 1
          }
        }
        new UsersResource().update(@updateSalesforceSettingSuccess, @handleApiErrors, params)
        @salesforce_authorized = false
        alertify.success this.$t('integrations.feedback.salesforceDisconnectSuccess')
        intercom_event_name = this.$t('integrations.feedback.salesforceDisconnectEvent')
        IntercomCtrl.trackEvent(intercom_event_name)
      else
        Loader.on()
        return window.parent.postMessage({ type: "redirect-integration", route: @salesforceOauthUrl }, "*") if window.parent && Session.current_user.new_ui
        window.location = @salesforceOauthUrl

    authorizeSalesforce: ->
      Loader.on()
      code = @$route.query.code
      sand = @$route.query.state.split(',')[1] == 'true' ? true : false
      @$router.replace(name: 'integrations')
      IntegrationsResource.authorize_salesforce(
        @authorizeSalesforceSuccess,
        @authorizeSalesforceFailure,
        code: code
        new_ui: Session.current_user.new_ui
        sandbox_test: sand
      )
      EventsBus.$emit 'salesforce-account-connected'

    authorizeSalesforceSuccess: (response) ->
      Session.updateCurrentUser(response.body.user)
      @current_user = Session.current_user
      Loader.off()
      alertify.success(this.$t('integrations.feedback.salesforceConnectSuccess'))
      @salesforce_authorized = true
      intercom_event_name = this.$t('integrations.feedback.salesforceConnectEvent')
      IntercomCtrl.trackEvent(intercom_event_name)

    authorizeSalesforceFailure: (response) ->
      Loader.off()
      alertify.error(response.body.error, 10)

    updateRdStationSetting: ->
      Loader.on()
      params = {
        id: Session.current_user.id,
        rd_station_setting_attributes: {
          id: @rd_station_setting.id,
          mark_lead_as_sale: @selectedRD,
          use_carousel: @rd_station_setting.use_carousel
        }
      }
      new UsersResource().update(@updateRdstationSettingSuccess, @handleApiErrors, params)


    redirectToRdstationOauthUrl: ->
      if @rdstation_authorized
        Loader.on()
        params = {
          id: Session.current_user.id,
          rd_station_setting_attributes: {
            id: @rd_station_setting.id,
            _destroy: 1
          }
        }
        new UsersResource().update(@updateRdstationSettingSuccess, @handleApiErrors, params)
        @rdstation_authorized = false
        alertify.success this.$t('integrations.feedback.rdStationDisconnectSuccess')
        @$router.push({ path: "/configuracoes/integracao" })
        intercom_event_name = this.$t('integrations.feedback.rdStationDisconnectEvent')
        IntercomCtrl.trackEvent(intercom_event_name)
      else
        Loader.on()
        window.location = @rdStationOauthUrl

    updateRdstationSettingSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('general.feedback.settingUpdated')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @closeForm()

    authorizeRdstation: ->
      Loader.on()
      code = @$route.query.code
      @$router.replace(name: 'integrations')
      IntegrationsResource.authorize_rdstation(
        @authorizeRdstationSuccess,
        @authorizeRdstationFailure,
        code: code
        new_ui: Session.current_user.new_ui
      )
      EventsBus.$emit 'rdstation-account-connected'

    authorizeRdstationSuccess: (response) ->
      Session.updateCurrentUser(response.body.user)
      @current_user = Session.current_user
      Loader.off()
      alertify.success(this.$t('integrations.feedback.rdStationConnectSuccess'))
      @rdstation_authorized = true
      @$router.push({ path: "/configuracoes/integracao?setting=rd_station" })
      intercom_event_name = this.$t('integrations.feedback.rdStationConnectEvent')
      IntercomCtrl.trackEvent(intercom_event_name)

    authorizeRdstationFailure: (response) ->
      Loader.off()
      alertify.error(response.body.error, 10)

    setStagesWebhook: (data) ->
      @webhook_triggers = data

    setStagesNectar: (data) ->
      @nectar_setting.triggers = data

    setStagesSalesforce: (data) ->
      @salesforce_setting.triggers = data

    toggleUseCarouselRd: ->
      @rd_station_setting.use_carousel = !@rd_station_setting.use_carousel

    toggleUseCarouselSp: ->
      @sharpspring_setting.use_carousel = !@sharpspring_setting.use_carousel

    toggleSandboxTestSf: ->
      @salesforce_setting.sandbox_test = !@salesforce_setting.sandbox_test

    toIntegration: (setting) ->
      path = '/configuracoes/integracao?setting='
      path += setting
      @$router.push { path: path }

  created: ->
    setTimeout =>
      @authorizeNylas() if @$route.query.state == 'nylas' && @$route.query.code
      @authorizeSalesforce() if @$route.query?.state?.split(',')[0] == 'salesforce' && @$route.query.code
      @authorizeRdstation() if @$route.query.state == 'rdstation' && @$route.query.code
    , 500

  mounted: ->
    Tooltip.initialize()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations.vue